import axios from "axios";
import { get_db_base } from "../DB";
//on local db for public role,
// give read, create, and update access for reports (since we can't access cookie)
// give read, create, and update access for files
// give read access for folders
// give read access for users
// give read access for roles

export async function getAccessToken(project) {
  let response = null;
  try {
    response = await axios.post(`${get_db_base(project)}auth/refresh`, {
      mode: "cookie"
    });
  } catch (e) {
    console.log(e);
  }
  return response?.data?.data?.access_token;
}

export async function getAuthConfig(project) {
  try {
    const token = await getAccessToken(project);
    if (!token) return undefined;
    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getUserByEmail(project, email) {
  let response = null;
  if (!email) return response;
  try {
    const authConfig = await getAuthConfig(project);
    response = await axios.get(
      `${get_db_base(project)}users?filter[email]=${email}&fields=*,role.*`,
      authConfig
    );
  } catch (e) {
    console.log(e);
  }
  return response;
}

export async function getCurrentUser(project) {
  let response = null;
  try {
    const authConfig = await getAuthConfig(project);
    response = await axios.get(
      `${get_db_base(project)}users/me?fields=*,role.*`,
      authConfig
    );
  } catch (e) {
    console.log(e);
  }
  return response;
}

export async function createNewReport(project, type, estimate) {
  let response = null;
  try {
    const authConfig = await getAuthConfig(project);
    response = await axios.post(
      `${get_db_base(project)}items/reports`,
      {
        type: type,
        generation_status: "started",
        client_name: estimate?.clientInfo?.clientName
      },
      authConfig
    );
  } catch (e) {
    console.log(e);
  }
  return response;
}

export async function importReportUrl(project, reportUrl, folderId, pdfName) {
  let response = null;
  try {
    const authConfig = await getAuthConfig(project);
    response = await axios.post(
      `${get_db_base(project)}files/import`,
      {
        url: reportUrl,
        data: {
          title: pdfName,
          filename_download: pdfName
        }
      },
      authConfig
    );
  } catch (e) {
    console.log(e);
  }
  const fileId = response?.data?.data?.id;
  if (!!fileId && !!folderId) {
    await moveReportToFolder(project, fileId, folderId);
  }
  return response;
}

async function moveReportToFolder(project, fileId, folderId) {
  let response = null;
  try {
    const authConfig = await getAuthConfig(project);
    response = await axios.patch(
      `${get_db_base(project)}files`,
      {
        data: {
          folder: folderId
        },
        keys: [fileId]
      },
      authConfig
    );
  } catch (e) {
    console.log(e);
  }
  return response;
}

export async function updateReport(
  project,
  reportId,
  reportUrl,
  reportFolderId,
  pdfName
) {
  let response = null;
  try {
    const submissionBody = {
      report_id: Number.parseInt(reportId) + 1000,
      generation_status: !!reportUrl ? "finished" : "error"
    };
    if (!!reportUrl) {
      const importResponse = await importReportUrl(
        project,
        reportUrl,
        reportFolderId,
        pdfName
      );
      const reportFileId = importResponse?.data?.data?.id;
      submissionBody.generated_report = reportFileId;
    }
    const authConfig = await getAuthConfig(project);
    response = await axios.patch(
      `${get_db_base(project)}items/reports/${reportId}`,
      submissionBody,
      authConfig
    );
  } catch (e) {
    console.log(e);
  }
  return response;
}

export async function requestPasswordReset(project, email) {
  let response = null;
  try {
    const userResponse = await getUserByEmail(project, email);
    const userId = userResponse?.data?.data?.id;
    if (!userId) {
      console.log("User doesn't exist notify admin");
    } else {
      response = await axios.post(
        `${get_db_base(project)}auth/password/request`,
        {
          email: email
        }
      );
    }
  } catch (e) {
    console.log(e);
  }
  return response;
}
